import { ChevronUp, ChevronDown } from "lucide-react";

// Comando discreto accanto al titolo di un'area della Home Lavoratore.
// collapsed=true -> chevron giù (indica "espandi"); collapsed=false -> chevron su ("comprimi").
export function AreaCollapseToggle({ collapsed, onToggle, testid }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onToggle}
      aria-expanded={!collapsed}
      aria-label={collapsed ? "Espandi area" : "Comprimi area"}
      title={collapsed ? "Espandi" : "Comprimi"}
      className="ml-auto inline-flex items-center justify-center h-6 w-6 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
    >
      {collapsed ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
    </button>
  );
}
